module.exports = __webpack_public_path__ + "static/img/Jeremiah-Nanai.58ea22e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremiah-Nanai.jpg
// module id = 6weI
// module chunks = 0